import React from "react";
import { Card, Typography } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";

const { Title } = Typography;

const topics = [
  {
    title: "NBA Fanbase",
    count: "150"
  },
  {
    title: "Basketball Club",
    count: "70"
  },
  {
    title: "Tournaments",
    count: "50"
  }
];


const Topics = () => {
  return (
    <>
      <div>
        <Card className="sidebarCard">
          <Title level={4}> Popular Topics </Title>
          {topics.map((item,index) => (
            <div key={index} className="py-2">
              <h3 className="text-lg">{item.title}</h3>
              <p>{`${item.count} members`}</p>
            </div>
          ))}
          <div className="mt-10 flex items-center">
            <p>See more</p>
            <CaretDownOutlined />
          </div>
        </Card>
      </div>
    </>
  );
};

export default Topics;
